import { Widget } from '@/components/widget';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FormSchemaEditor } from '@/components/form-schema-editor';
import { useListener } from '@/hooks/use-listener';
import { useEmitter } from '@/hooks/use-emitter';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';
import { WidgetID } from '@/widget-store';

export function SchemaEditorWidget({ id }: { id: WidgetID }) {
  const [searchParams] = useSearchParams();
  const schemaFromUrl = searchParams.get('schema');

  const [initialSchema, setInitialSchema] = useState<object>(() => {
    if (schemaFromUrl) { try { return JSON.parse(schemaFromUrl); } catch { return {}; } }
    return {};
  });
  const [initialUiSchema, setInitialUiSchema] = useState<object>({});
  const [currentSchema, setCurrentSchema] = useState<object>(() => {
    if (schemaFromUrl) { try { return JSON.parse(schemaFromUrl); } catch { return {}; } }
    return {};
  });
  const [currentUiSchema, setCurrentUiSchema] = useState<object>({});

  const tabId = useTabId();
  const screenId = useScreenId();
  const emit = useEmitter({ id, listenersPrefix: `${tabId}/${screenId}` });

  useListener({
    id,
    type: 'SchemaLoaded',
    listenerFn: (data) => {
      const item = data?.[0] ?? {};
      const s = (item.schema as object) ?? {};
      const ui = (item.uiSchema as object) ?? {};
      setInitialSchema(s);
      setInitialUiSchema(ui);
      setCurrentSchema(s);
      setCurrentUiSchema(ui);
    },
  });

  function handleSchemaChange(s: object) {
    setCurrentSchema(s);
    emit({ type: 'SchemaChanged', data: [{ schema: s, uiSchema: currentUiSchema }] });
  }

  function handleUiSchemaChange(ui: object) {
    setCurrentUiSchema(ui);
    emit({ type: 'SchemaChanged', data: [{ schema: currentSchema, uiSchema: ui }] });
  }

  return (
    <Widget id={id} title="Form Editor">
      <div className="h-full">
        <FormSchemaEditor
          initialSchema={initialSchema}
          initialUiSchema={initialUiSchema}
          onSchemaChange={handleSchemaChange}
          onUiSchemaChange={handleUiSchemaChange}
        />
      </div>
    </Widget>
  );
}
